import {removeToken, service, setToken} from "./network";


function handle_server_error(error, dispatch, history) {
    console.log(error);
    if (error.response) {
        if (error.response.status === 403) {
            logout(dispatch, history)
        } else {
            dispatch({
                type: "LOAD_JOBS_ERROR",
                payload: {
                    type: 'error',
                    payload: "Es ist ein Fehler beim Laden des Job-Dashboards aufgetreten. Bitte versuchen Sie es später erneut. Status Code: " + error.response.status
                }
            })
        }
    } else {
        dispatch({
            type: "LOAD_JOBS_ERROR",
            payload: {type: 'error', payload: "Die Anfrage hat ein Zeitlimit überschritten."}
        })
    }
}

function load_all_jobs(dispatch, history) {
    dispatch({type: "FETCH_JOBS"});
    service.get('/v1/dashboard_client/jobs').then((e) => {
        dispatch({type: "RECEIVED_JOBS", payload: e.data});
    }).catch(function (error) {
        handle_server_error(error, dispatch, history);
    })
}

function loadStatisticsForOneJob(dispatch, jobid, history) {
    dispatch({type: "FETCH_STATISTICS"});
    service.get(`/v1/dashboard_client/jobs/${jobid}`).then((e) => {
        dispatch({type: "RECEIVED_STATISTICS", payload: {[jobid]: e.data}});
    }).catch(function (error) {
        if (typeof error.response != "undefined") {
            if (error.response.status === 403) {
                logout(dispatch, history)
            } else {
                dispatch({
                    type: "RECEIVED_STATISTICS_ERROR",
                    payload: {
                        [jobid]: {error: "Es ist ein Fehler beim Laden des Job-Dashboards aufgetreten. Bitte versuchen Sie es später erneut. Status Code: " + error.response.status}
                    }
                })
            }
        } else {
            dispatch({
                type: "RECEIVED_STATISTICS_ERROR",
                payload: {[jobid]: {error: "Es ist ein Fehler beim Laden des Job-Dashboards aufgetreten. Bitte versuchen Sie es später erneut."}}
            })
        }
    })
}

function resetServerError(dispatch) {
    dispatch({type: "SERVER_ERROR_RESET"});
}

function login(dispatch, username, password, history) {
    dispatch({type: "FETCH_LOGIN"});
    service.post('/v1/dashboard_client/login', {username, password})
        .then((e) => {
            setToken(e.data['auth_token'])
            dispatch({type: "RECEIVED_LOGIN"})
            history.push('/app/dashboard')
        }).catch(function (error) {
        // Send dispatch for error with response
        dispatch({
            type: "LOGIN_ERROR",
            payload: {
                type: 'error',
                payload: "Deine E-Mail-Adresse oder das Passwort ist falsch, bitte versuche es erneut."
            }
        })
    })
}

function logout(dispatch, history) {
    removeToken()
    dispatch({type: "LOGOUT"});
    history.push('/login')
}

function sendPasswordRequest(dispatch, email) {
    dispatch({type: "FETCH_RESET_PASSWORD_REQUEST"});
    service.post('/v1/dashboard_client/user/reset_password', {email: email})
        .then((e) => {
            dispatch({
                type: "RECEIVED_RESET_PASSWORD_REQUEST",
                payload: {
                    type: 'success',
                    payload: "Ihr Link zum Zurücksetzen des Passworts wurde Ihnen per E-Mail zugeschickt."
                }
            })
            // history.push('/app/dashboard')
        }).catch(function (error) {
        if (error.response) {
            dispatch({
                type: "RESET_PASSWORD_ERROR",
                payload: {
                    type: 'error',
                    payload: "Wir konnten keinen Benutzer mit dieser E-Mail-Adresse finden. Bitte korrigieren Sie Ihre E-Mail und versuchen Sie es erneut."
                }
            })
        }
    });
}

function changePassword(dispatch, token, confirmPasswordValue, history) {
    dispatch({type: "FETCH_CHANGE_PASSWORD"});
    removeToken();
    service.post(`/v1/dashboard_client/user/reset_password/${token}`, {password: confirmPasswordValue})
        .then((e) => {
            dispatch({
                type: "CHANGE_PASSWORD_DONE",
                payload: {type: 'success', payload: "Ihr Passwort wurde erfolgreich geändert."}
            })
            debugger
            history.push('/login')
        }).catch(function (error) {
        if (error.response) {
            dispatch({
                type: "CHANGE_PASSWORD_DONE",
                payload: {
                    type: 'error',
                    payload: "Ihr Passwort wurde nicht erfolgreich geändert. Bitte versuchen Sie es erneut oder wenden Sie sich an den Systemadministrator."
                }
            })
            history.push('/login')
        }
    });
}

export {load_all_jobs, loadStatisticsForOneJob, resetServerError, login, logout, sendPasswordRequest, changePassword};